export default() => {
  // IE11 hack
  // IE11 throws an error if the cart icon is clicked, something to do with 
  // blur not being supported. I think it is how either Vue or vue-js-modal
  // handles the event.
  if (typeof SVGElement.prototype.blur == 'undefined') {
    SVGElement.prototype.blur = function(){};
  }
}


// WEBPACK FOOTER //
// ./_js/lib/addBlurEventToSvg.js